import { GET_ALL_PRODUCTEURS } from "../actions/producteurs.actions";

const initialState = {};

export default function producteursReducer(state = initialState, action) {
  switch (action.type) {
    case GET_ALL_PRODUCTEURS:
      return action.payload;
    default:
      return state;
  }
}
